module.exports = __webpack_public_path__ + "img/cats-can-code-1.33f76f67.png";